import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
export function FoundersLetter() {
  return <>
      <Helmet data-id="element-1533">
        <title data-id="element-1534">Founder's Letter — Lazy Monk Labs</title>
        <meta name="description" content="A note on why Lazy Monk Labs exists, and where it's going." data-id="element-1535" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] font-sans selection:bg-[#2B2B2B] selection:text-white" data-id="element-1536">
        {/* Simple Navigation - Back to Home */}
        <nav className="pt-8 px-6 max-w-2xl mx-auto" data-id="element-1537">
          <Link to="/" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors" data-id="element-1538">
            ← Return to Home
          </Link>
        </nav>

        <main className="px-6 py-20 max-w-2xl mx-auto" data-id="element-1539">
          {/* Header */}
          <header className="mb-16" data-id="element-1540">
            <h1 className="text-3xl md:text-4xl font-serif font-medium text-[#F5F5F5] mb-4" data-id="element-1541">
              A Letter from the Founder
            </h1>
            <p className="text-lg text-gray-500 font-light" data-id="element-1542">
              Why Lazy Monk Labs exists, and where it's going.
            </p>
          </header>

          {/* Body Content - Reference Document Style */}
          <article className="prose prose-invert prose-lg max-w-none" data-id="element-1543">
            <div className="space-y-8 text-[17px] leading-[1.7] text-gray-300 font-light" data-id="element-1544">
              <p data-id="element-1545">
                Lazy Monk Labs didn't start as a business idea. It started as a
                personal attempt to understand why smart, capable people—myself
                included—repeat the same patterns, even when they know better.
              </p>

              <p data-id="element-1546">
                For years, I approached this problem through the lens of mental
                models. I thought if I could just build a better "operating
                system" for my mind—better logic, better frameworks, better
                discipline—the outcomes would change.
              </p>

              <p data-id="element-1547">
                But they didn't. The logic improved, but the loops remained.
              </p>

              <p data-id="element-1548">
                That failure forced a deeper realization: Logic is the surface
                layer. Patterns are the deeper layer. We don't make decisions
                based on what we know; we make decisions based on the recurring
                feedback loops we are stuck in.
              </p>

              <p data-id="element-1549">
                This shift—from "improving the mind" to "recognizing the
                pattern"—is the core of Lazy Monk Labs.
              </p>

              <p data-id="element-1550">
                We are a pattern recognition company. We exist to make the
                invisible mechanics of human behavior visible. Not to judge
                them, not to "fix" them with advice, but to engineer the
                awareness required to step out of them.
              </p>

              <p data-id="element-1551">
                We start with humans (Phase 1) because humans are the most
                complex, nonlinear systems. If we can reliably map the patterns
                of a single human consciousness, we can map the patterns of
                teams, organizations, and eventually, markets.
              </p>

              <p data-id="element-1552">
                Our flagship product, Decoder, is the first step. It is not a
                therapy tool. It is not a personality test. It is a system for
                isolating the specific bug in your operating code.
              </p>

              <p data-id="element-1553">
                We are building for the long term. This is not about quick
                hacks. It is about the slow, precise work of understanding the
                source code of reality.
              </p>

              <p data-id="element-1554">
                If you are here, you are likely someone who values truth over
                comfort. Welcome.
              </p>
            </div>

            {/* Signature */}
            <div className="mt-16 pt-8 border-t border-[#2B2B2B]" data-id="element-1555">
              <p className="text-[#F5F5F5] font-medium" data-id="element-1556">Anish Khandelwal</p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1557">
                Founder, Lazy Monk Labs
              </p>
            </div>
          </article>

          {/* Subtle Next Step */}
          <div className="mt-24 flex justify-start" data-id="element-1558">
            <Link to="/decode" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors border-b border-transparent hover:border-[#F5F5F5] pb-0.5" data-id="element-1559">
              View the Decoder &rarr;
            </Link>
          </div>
        </main>

        {/* Minimal Footer */}
        <footer className="py-12 text-center border-t border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-1560">
          <p className="text-xs text-gray-600" data-id="element-1561">Truth, engineered.</p>
        </footer>
      </div>
    </>;
}